// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var ReactHotToast = require("react-hot-toast");
var CommonStyleTypes = require("../../../shared/src/types/CommonStyleTypes.bs.js");
var BrowserComponents_Icon = require("../components/BrowserComponents_Icon.bs.js");

var _map = {"bottomCenter":"bottom-center","bottomLeft":"bottom-left","bottomRight":"bottom-right","topCenter":"top-center","topLeft":"top-left","topRight":"top-right"};

var _revMap = {"bottom-center":"bottomCenter","bottom-left":"bottomLeft","bottom-right":"bottomRight","top-center":"topCenter","top-left":"topLeft","top-right":"topRight"};

function positionToJs(param) {
  return _map[param];
}

function positionFromJs(param) {
  return _revMap[param];
}

function spacingToRemStyle(spacing) {
  return Relude_Float.toString(Curry._1(BrowserStyle.Point.toRemValue, Curry._1(BrowserStyle.Spacing.toPoint, spacing))) + "rem";
}

function makeProps(durationInMsOpt, positionOpt) {
  var durationInMs = durationInMsOpt !== undefined ? durationInMsOpt : 5000;
  var position = positionOpt !== undefined ? positionOpt : "bottomCenter";
  var partial_arg = {
    duration: durationInMs,
    style: {
      "background-color": BrowserStyle.Color.toString({
            TAG: /* Blue */0,
            _0: /* Dark */1
          }),
      "border-radius": "0.5rem",
      color: BrowserStyle.Color.toString({
            TAG: /* White */7,
            _0: /* Light */2
          }),
      "font-family": Curry._1(BrowserStyle.Typography.Font.toString, /* OpenSans */1),
      "font-size": Relude_Int.toString(CommonStyleTypes.Point.toPx(Curry._1(CommonStyleTypes.Typography.Size.toPoint, /* Large */4))) + "px",
      "font-weight": Relude_Int.toString(500),
      "max-width": "90%",
      "padding-bottom": spacingToRemStyle(/* Medium */4),
      "padding-left": spacingToRemStyle(/* Large */5),
      "padding-right": spacingToRemStyle(/* Large */5),
      "padding-top": spacingToRemStyle(/* Medium */4),
      "text-align": "center"
    }
  };
  var partial_arg$1 = positionToJs(position);
  return function (param, param$1) {
    var tmp = {
      toastOptions: partial_arg
    };
    if (partial_arg$1 !== undefined) {
      tmp.position = Caml_option.valFromOption(partial_arg$1);
    }
    if (param !== undefined) {
      tmp.key = Caml_option.valFromOption(param);
    }
    return tmp;
  };
}

function displayMessage(icon, message) {
  return Relude_IO.suspend(function (param) {
              var tmp = {};
              var tmp$1 = Relude_Option.map((function (icon) {
                      return React.createElement(BrowserComponents_Icon.make, {
                                  color: {
                                    TAG: /* White */7,
                                    _0: /* Light */2
                                  },
                                  icon: {
                                    TAG: /* Small */1,
                                    _0: icon
                                  }
                                });
                    }), icon);
              if (tmp$1 !== undefined) {
                tmp.icon = Caml_option.valFromOption(tmp$1);
              }
              ReactHotToast.toast(message, tmp);
              
            });
}

exports.positionToJs = positionToJs;
exports.positionFromJs = positionFromJs;
exports.makeProps = makeProps;
exports.displayMessage = displayMessage;
/* react Not a pure module */
